import images from "../afbeeldingen/images";

const ProjectGrafanaDashboards = {
  title: "Grafana Dashboards",
  year: "Stage",
  subtitle: "Context",
  description:
    "In Grafana zelf zijn er heel veel dashboards die gemaakt zijn. Maar er komen nog heel veel dashboards bij. Voor het filteren van de dashboards zijn er ook tags. Die zijn makkelijk te gebruiken om te filteren op dashboards. Maar in de hostapplicatie Phoenix is er nergens iets waar je kan zien welke dashboards er allemaal zijn. Ook niet welke dashboards er allemaal zijn voor de specifieke applicatie. Dus telkens als je een dashboard wilt bekijken, moet je naar Grafana gaan en daar de dashboards opzoeken, en dat is niet handig. Daarom heb ik een applicatie gemaakt waar je alle dashboards kunt zien en die op de pagina kan openen. Ook heb ik een offcanvas gemaakt waar je voor de applicatie waar je in bent, dat je daar kunt zien welke dashboards er zijn voor die applicatie en voor die omgeving. In de offcanvas kan je ook de dashboards openen.",
  extraContentHTML: `
        <h3>De Grafana dashboard pagina</h3>  
        Als je de Grafana-dashboardapplicatie opent, krijg je een overzicht te zien van alle dashboards die er zijn.
        Op deze pagina kan je filteren op tags of je kan gewoon zoeken door de pagina’s die er zijn.
        Ook kan je gewoon op een dashboard klikken dat je wilt openen en dan opent dat automatisch.
        <br>
        <img src="${images.grafanpagina}"  style="width:100%; height:auto;" />
        <br>
        Als je wilt filteren op tags, dan kan je gewoon bepaalde tags kiezen waar je op wilt filteren.
        Je kan filteren op zoveel tags als je wilt, maar je moet wel zien dat de tags bij elkaar horen.
        Daarmee bedoel ik dat je niet eender welke tag kan samenvoegen.
        De tags moeten wel bij een bepaald dashboard aangewezen zijn.
        Bijvoorbeeld: je filtert op de tags DEV, SIT en VM
        <br>
        <img src="${images.grafanafilter}"  style="width:100%; height:auto;" />
        <br>
        Dan krijg je vervolgens deze dashboards te zien.
        <br>
        <img src="${images.grafanafilterDashboards}"  style="width:100%; height:auto;" />
        <br>
        En als je er een wilt openen, dan klik je gewoon op het dashboard dat je wilt, en dan opent die op de pagina zelf.
        <h3>De Grafana offcanvas</h3>
        Als je op een applicatie zit en je wilt heel graag zien welke dashboards er allemaal zijn voor de omgeving waarin je zit, dan kan je dat heel makkelijk zien in de offcanvas.
        In deze offcanvas kan je kijken welke dashboards er allemaal zijn voor de omgeving en kan je ook het dashboard daar openen.
        Zoals je op de foto kan zien, is er voor de applicatie Grafana één dashboard genaamd sit-Grafana.
        Omdat we in de SIT-omgeving zitten, zie je alleen maar de dashboards voor SIT.
        Deze kan je dan ook hier openen door op de naam te klikken.
        <br>
        <img src="${images.GrafanaOffcanvas}"  style="width:100%; height:auto;" />
        <br>
        Het kan natuurlijk ook voorvallen dat er geen dashboards zijn voor een bepaalde applicatie, zodat je hier onderaan ziet.
        Je ziet hier dat er geen Grafana-dashboards zijn voor de applicatie translations.
        Indien er geen dashboards zijn voor deze applicatie en deze omgeving, kan je altijd klikken op ‘View All Dashboards
        om zo naar de Grafana-dashboardapplicatie te gaan.
        Je kan niet alleen naar de dashboardspagina gaan als er geen dashboards zijn, maar ook als er wel dashboards zijn.
        <br>
        <img src="${images.grafanaNoDashboards}"  style="width:100%; height:auto;" />
        <br>
        <h3>Besluit</h3>
        Tijdens dit project heb ik geleerd hoe ik effectief gebruik kan maken van een iframe om Grafana-dashboards direct op een pagina weer te geven. Dit maakte het voor gebruikers mogelijk om in één oogopslag belangrijke informatie te zien zonder de pagina te hoeven verlaten.
        Daarnaast heb ik een offcanvas-component gebouwd, waarin dashboards konden worden gefilterd op zowel de omgeving (SIT, UAT, PRD) als de specifieke applicatie waarmee de gebruiker op dat moment werkte. Dit zorgde voor een overzichtelijke en gebruiksvriendelijke ervaring.
        Wat ik vooral waardevol vond, was het actieve contact met de eindgebruiker. Ik stelde regelmatig vragen om zeker te weten dat de implementatie aansloot bij zijn verwachtingen. Wanneer er aanpassingen nodig waren, zorgde ik ervoor dat deze snel en zorgvuldig werden doorgevoerd. Dit leerde me niet alleen technisch nauwkeurig te werken, maar ook hoe belangrijk directe communicatie is bij het leveren van een goed eindproduct.
      `,
  extraContentJSX: (
    <>
      <h3>Bekijk Documentatie</h3>
      <p>
        Indien de foto's niet duidelijk zijn, kan je de documentatie altijd
        bekijken bij het klikken op deze knop:
      </p>
      <a
        href="../Documentatie_Grafana_Dashboards.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className={`btn mt-2 btn-primary`}
      >
        Bekijk Documentatie
      </a>
    </>
  ),
  image: images.grafanaLogo,
};
export default ProjectGrafanaDashboards;
